/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import zeroToFive from "../assets/image/workdetails/zerotofive.svg";
import fiveToFifty from "../assets/image/workdetails/fivetofifty.svg";
import Fifty from "../assets/image/workdetails/fifty.svg";
import oneFifty from "../assets/image/workdetails/onefifty.svg";

export const skillsArray = [
  "Steam cleaning",
  "Sweeping",
  "Window cleaning",
  "Pickup trucks",
  "Awning cleaning",
  "Building wash",
  "Dumpster sanitation",
  "Maintenance tech",
  "Roof clean off",
  "Storm drain cleaning",
  "Others",
];

export const employeeCount = [
  { id: 1, count: "Less than 5", icon: zeroToFive },
  { id: 2, count: "Between 5 and 50", icon: fiveToFifty },
  { id: 3, count: "More than 50", icon: Fifty },
  { id: 4, count: "More than 150", icon: oneFifty },
];
export const companyInfoCount = [];
export const companyInfoContractors = ["0", "1-10", "11-100", "Above 100"];
export const companyInfoTrucks = ["0", "1-10", "11-100", "Above 100"];
export const ownerOperatorWorkRadius = ["0", "5", "10", "20"];
export const hour = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
export const minute = ["00", "15", "30", "45"];
export const timePeriod = ["AM", "PM"];
export const employeeRoles = ["CXO", "EXECUTIVE", "ADMINISTRATOR", "SUPERVISOR", "TECHNICIAN", "HUB"]
